export default "__VITE_ASSET__DciRAGHC__"